import { api } from './client'

// Participant feedback. Submit is open to enrolled participants; listing and
// CSV export are admin-only (enforced server-side).
export const submitFeedback = (pid, payload) =>
  api.post(`/feedback/programs/${pid}`, payload).then((r) => r.data)

export const getMyFeedback = (pid) =>
  api.get(`/feedback/programs/${pid}/me`).then((r) => r.data)

export const listFeedback = (pid) =>
  api.get(`/feedback/programs/${pid}`).then((r) => r.data)

// Nama berkas datang dari header Content-Disposition milik server — pola yang
// sama dengan appraisals.api.js — bukan disusun ulang di sini.
function namaDariHeader(res, cadangan) {
  const cd = res.headers?.['content-disposition'] || ''
  const m = /filename="?([^";]+)"?/i.exec(cd)
  return m ? decodeURIComponent(m[1]) : cadangan
}

/** Ekspor feedback program: csv | xlsx | pdf. */
export const downloadFeedbackExport = (pid, format = 'csv') =>
  api
    .get(`/feedback/programs/${pid}/export.${format}`, { responseType: 'blob' })
    .then((r) => ({ blob: r.data, filename: namaDariHeader(r, `feedback.${format}`) }))

// QR berisi tautan menuju form feedback, untuk diproyeksikan ke kelas.
// Ada di /programs, bukan /feedback: endpoint-nya melayani semua tujuan ?goto=
// (pretest, posttest, feedback) dan alamatnya dibangun dari subdomain lembaga
// pemilik program.
export const getFeedbackQr = (pid) =>
  api.get(`/programs/${pid}/goto-qr`, { params: { target: 'feedback' } }).then((r) => r.data)
